import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import 'jquery-validation';
import Global from "../common/global";
import { ButtonHelper } from './../common/buttonHelper';

export class Basket {
    private _form: JQuery<HTMLElement> | undefined;
    private _validator: any;
    private errorModal: JQuery<HTMLElement>;

    private maxNumberOfRooms: number;
    private totalRoomsSelected: number;

    private roomVariants: string[];
    private roomCount: number[];
    
    private roomIds: number[];
    private mealIds: number[];
    private quotedPrices: number[];
    private rateKeys: string[];

    constructor() {
        this.errorModal = $("#errorModal");

        this.maxNumberOfRooms = parseInt($('#SearchBarForm_MaxNumberOfRooms').val() as string) || 0;
        this.totalRoomsSelected = 0;

        this.roomVariants = [];
        this.roomCount = [];
        this.roomVariants = [];

        this.roomIds = [];
        this.mealIds = [];
        this.quotedPrices = [];
        this.rateKeys = [];

        // Set initial UI state: hide all or show "no-selection"
        this._updateUI(0, 0, '', false, false, parseInt($("#SearchBarForm_TotalRooms").val() as string) || 0, 0, 0, '');
    }

    private _validateSpecialRequest(basketItemRef: JQuery<HTMLElement>): boolean {
        let isValid = true;
        basketItemRef.find('.special-request-field').each((_, item) => {
            $(item).rules('add', { alphanumericRestricted: true });
            isValid = $(item).valid() as boolean;
        });
        return isValid;
    }

    private _midPointRoundDown(number: number): number {
        return number % 1 === 0.5 ? Math.floor(number) : Math.round(number);
    }

    public updateRooms(buttonRef: JQuery<HTMLElement>): void {
        this.totalRoomsSelected = 0;
        const totalRoomsSearched = parseInt($("#SearchBarForm_TotalRooms").val() as string) || 0;
        let totalPrice = 0;
        let totalPayTodayPrice = 0;
        let totalCashbackPrice = 0;

        this.roomCount = [];
        this.roomVariants = [];
        this.roomIds = [];
        this.mealIds = [];
        this.quotedPrices = [];
        this.rateKeys = [];

        const roomGroup = buttonRef.closest('.db-hotel-info-rooms');
        const providerId = roomGroup.data('provider-id');
        const currencyId = roomGroup.data('currency-id');
        const bedbankType = roomGroup.data('bedbank-type');
        const pageRef = roomGroup.data('page-ref');
        const currencySymbol = roomGroup.data('currency');
        const currencySymbolAfter = roomGroup.data('currency-symbol-after');
        const currencyRounding = roomGroup.data('currency-rounding');

        roomGroup.find('.db-room-card').each((_, card) => {
            const $card = $(card);
            console.log($card);
            if (providerId === $card.data('provider-id')) {
                const price = parseFloat($card.data('price'));
                const payTodayPrice = parseFloat($card.data('pay-today-price'));
                const cashbackPrice = parseFloat($card.data('cashback-price'));
                const variant = $card.data('variant');
                let roomsSelected = parseInt($card.find('.select-rooms').val() as string) || 0;

                const roomId = $card.data('room-id');
                const mealId = $card.data('meal-id');
                const quotedPrice = $card.data('quoted-price');
                const rateKey = $card.data('rate-key');

                if (roomsSelected > 0) {
                    this.totalRoomsSelected += roomsSelected;
                    totalPrice += price * roomsSelected;
                    totalPayTodayPrice += payTodayPrice * roomsSelected;
                    totalCashbackPrice += cashbackPrice * roomsSelected;

                    this.roomIds.push(roomId);
                    this.roomVariants.push(variant);
                    this.mealIds.push(mealId);
                    this.quotedPrices.push(quotedPrice);
                    this.rateKeys.push(rateKey);
                    this.roomCount.push(roomsSelected);
                }
            }
        });

        this._updateUI(totalPrice, totalPayTodayPrice, currencySymbol, currencySymbolAfter, currencyRounding, totalRoomsSearched, providerId, currencyId, bedbankType, pageRef);
    }

    private _updateUI(
        totalPrice: number,
        totalPayTodayPrice: number,
        currencySymbol: string,
        currencySymbolAfter: boolean,
        currencyRounding: boolean,
        totalRoomsSearched: number,
        providerId: number,
        currencyId: number,
        bedbankType: string,
        pageRef?: string
    ) {
        const $noSelection = $(".db-selected-rooms.no-selection");
        const $selection = $(".db-selected-rooms.selection");
        const $diffSelection = $(".db-selected-rooms.diff-selection");

        // Hide all by default
        $noSelection.removeClass('show').addClass('hidden');
        $selection.removeClass('peek').addClass('hidden');
        $diffSelection.removeClass('show').addClass('hidden');

        if (this.totalRoomsSelected === 0) {
            // No rooms selected
            $noSelection.removeClass('hidden').addClass('show');

            $(".room-selection-message").html("");
            $(".db-total-price").html("");
            $(".room-selection-pay-today").html("");

        } else if (this.totalRoomsSelected > totalRoomsSearched) {
            // Selected more rooms than searched
            $diffSelection.removeClass('hidden').addClass('show');

            $(".room-selection-message").html("");
            $(".room-selection-total-price").html("");
            $(".room-selection-pay-today").html("");

        } else {
            // Normal selection
            $selection.removeClass('hidden').addClass('peek');

            const roomMessage = this.totalRoomsSelected === 1 ? window._screenMessages.Room : window._screenMessages.Rooms;
            $(".room-selection-message").html(window._screenMessages.RoomSelectionMessage.replace("[ROOMS]", `${this.totalRoomsSelected} ${roomMessage}`));

            let finalPrice = currencyRounding ? totalPrice.toFixed(0) : totalPrice.toFixed(2);
            let finalPayTodayPrice = currencyRounding ? totalPayTodayPrice.toFixed(0) : totalPayTodayPrice.toFixed(2);
            
            if (currencySymbolAfter) {
                $(".room-selection-total-price").html(`${finalPrice} ${currencySymbol}`);
                $(".room-selection-pay-today").html(`${window._screenMessages.PayableToday}: ${finalPayTodayPrice} ${currencySymbol}`);
            } else {
                $(".room-selection-total-price").html(`${currencySymbol}${Global.formatNumber(parseFloat(finalPrice), 2, true)}`);
                $(".room-selection-pay-today").html(`${window._screenMessages.PayableToday}: ${currencySymbol}${Global.formatNumber(parseFloat(finalPayTodayPrice), 2, true)}`);
            }

            $("#btnAddToBasket").data('provider-id', providerId)
                .data('currency-id', currencyId)
                .data('bedbank-type', bedbankType);

            if (pageRef) {
                $("#btnAddToBasket").data('page-ref', pageRef);
            }
        }
    }

    public addToBasket(buttonRef: JQuery<HTMLElement>, pageRef?: string) {
        const totalRoomsSearched = parseInt($("#SearchBarForm_TotalRooms").val() as string) || 0;

        const $noSelection = $(".db-selected-rooms.no-selection");
        const $selection = $(".db-selected-rooms.selection");
        const $diffSelection = $(".db-selected-rooms.diff-selection");

        // Hide all by default
        $noSelection.removeClass('show').addClass('hidden');
        $selection.removeClass('show').addClass('hidden');
        $diffSelection.removeClass('show').addClass('hidden');

        $('#errorModal .errorText').each((_, elem) => {
            $(elem).addClass('hidden');
        });

        if (this.totalRoomsSelected < totalRoomsSearched) {
            // Selected more rooms than searched
            ButtonHelper.resetSpinnerButtons();

            $diffSelection.removeClass('hidden').addClass('show');

            $(".room-selection-message").html("");
            $(".room-selection-total-price").html("");
            $(".room-selection-pay-today").html("");
        } else if (this.roomVariants.length === this.roomCount.length) {
            $selection.removeClass('hidden').addClass('show');
            // Old ones - need adding back in if we reintroduce the flexible calendar
            //const startDate = $("#BreakStartDateCounter").val();
            //const endDate = $("#BreakEndDateCounter").val();
            //const roomInfoString = $("#RoomInfoString").val();
            const startDate = $("#SearchBarForm_ArrivalDateCounter").val();
            const endDate = $("#SearchBarForm_DepartureDateCounter").val();
            const roomInfoString = $("#SearchBarForm_RoomInfoString").val();

            if (pageRef === "BedBanks") {
                const providerId = buttonRef.data('provider-id');
                const itemCurrency = buttonRef.data('currency-id');
                const bedbankType = buttonRef.data('bedbank-type');

                window.location.href = `/BedBanks/AddToBasketSunHotels?bedbankSourceType=${bedbankType}&providerId=${providerId}&roomIds=${this.roomIds.join(',')}&mealIds=${this.mealIds.join(',')}&quotedPrices=${this.quotedPrices.join(',')}&startDate=${startDate}&endDate=${endDate}&numberOfRooms=${this.roomCount.join(',')}&roomInfoString=${roomInfoString}&currencyId=${itemCurrency}&rateKeys=${this.rateKeys.join(',')}`;
            } else {
                buttonRef.prop('disabled', true);
                buttonRef.find('.spinner').removeClass('hidden');

                var addToBasketUrl = `/Basket/AddToBasket?variants=${this.roomVariants.join(',')}&startDate=${startDate}&endDate=${endDate}&numberOfRooms=${this.roomCount.join(',')}&roomInfoString=${roomInfoString}&pageRef=${pageRef}`;

                const isPackageDeal = buttonRef.data('is-package-deal');

                if (isPackageDeal) {
                    const packageDealId = buttonRef.data('package-deal-id');
                    const packageDealRateCodes = buttonRef.data('package-deal-rate-codes');
                    addToBasketUrl += `&isPackageDeal=true&packageDealId=${packageDealId}&packageDealRateCodes=${packageDealRateCodes}`;
                }

                $.ajax({
                    type: 'GET',
                    url: addToBasketUrl,
                    success: (data: any) => {
                        if (this.totalRoomsSelected === 1) {
                            const providerId = buttonRef.data('provider-id') as string;
                            const addOnData = data;

                            $.ajax({
                                type: 'GET',
                                url: `/Basket/CheckProviderAddOns?providerId=${providerId}`,
                                success: (addOnResponse: any) => {
                                    if (addOnResponse === "true") {
                                        // Hide selection tray on success
                                        $('.db-selected-rooms.selection').removeClass('show').addClass('hidden');

                                        $("#AddOnsContainer").html(addOnData);
                                        const modalEl = document.getElementById("addOnsTray");
                                        if (modalEl) {
                                            const modal = new bootstrap.Modal(modalEl, {
                                                backdrop: "static",
                                                keyboard: false
                                            });
                                            modal.show();
                                        }
                                    } else {
                                        window.location.href = '/Booking/PersonalDetailsForm';
                                    }
                                },
                                error: (xhr: JQuery.jqXHR, status: string) => {
                                    let errorMessage = '';
                                    if (xhr.responseJSON?.publicMessage) {
                                        errorMessage += xhr.responseJSON.publicMessage;
                                    }
                                    if (xhr.responseJSON?.privateMessage) {
                                        errorMessage += ' ' + xhr.responseJSON.privateMessage;
                                    }
                                    console.error(errorMessage);
                                }
                            });

                        } else {
                            window.location.href = '/Booking/PersonalDetailsForm';
                        }
                    },
                    error: (xhr: JQuery.jqXHR, status: string) => {
                        let errorMessage = '';
                        if (xhr.responseJSON?.publicMessage) {
                            errorMessage += xhr.responseJSON.publicMessage;
                        }
                        if (xhr.responseJSON?.privateMessage) {
                            errorMessage += ' ' + xhr.responseJSON.privateMessage;
                        }
                        console.error(errorMessage);

                        buttonRef.prop('disabled', false);
                        buttonRef.find('.spinner').addClass('hidden');
                    }
                });
            }
        }
    }

    public updateAddOns(buttonRef: JQuery<HTMLElement>): void {
        const basketItemId = buttonRef.closest('.db-addons-item').data('basket-item-id');
        const providerAddOnId = buttonRef.closest('.db-addons-item').data('provider-add-on-id');

        let addOnChangeUrl = buttonRef.hasClass('db-counter-remove')
            ? `/Basket/RemoveAddOn?basketItemId=${basketItemId}&providerAddOnId=${providerAddOnId}`
            : `/Basket/AddAddOn?basketItemId=${basketItemId}&providerAddOnId=${providerAddOnId}`;

        $.ajax({
            type: 'GET',
            url: addOnChangeUrl,
            success: () => {
            },
            error: (xhr: JQuery.jqXHR, status: string) => {
                console.error("Failed to update addon:", xhr.responseText || status);
            }
        });
    }
}
